define([
    'underscore',
    'edge/platform/base/BaseCtrl',
    'exports?phoneUtils!libphonenumber'// without 'exports' doesn't export a variable when is loaded as a module
], (_, BaseCtrl, phoneUtils)=> {
    const fn = ($scope, $window, LocaleService, $stateParams, StateUtils, LoginLinkDev, LoginLinkTest, AAADEV, AAATEST, GWDEV, GWTEST)=> {
        const ctrl = Object.create(BaseCtrl);

        ctrl.init = ()=> {
            $scope.submission = $stateParams.quoteSummary;
            $scope.today = new Date();

            $scope.chosenQuote = _.findWhere($scope.submission.quoteData.offeredQuotes, {publicID: $scope.submission.bindData.chosenQuote});
            $scope.chosenPlan = _.findWhere($scope.submission.bindData.paymentPlans, {billingId: $scope.submission.bindData.selectedPaymentPlan});

            $scope.accountHolderAddress = $scope.submission.draftData.policyAddress;
            $scope.accountHolder = $scope.submission.draftData.accountHolder;
            $scope.accountHolder.contactNumber = $scope.accountHolder.homeNumber; // alternative if we need to use primary contact number this._contactNumber();
        };

        ctrl.printQuote = ()=> {
            $window.print();
        };


        //TODO:this function is used for login from dev and test environment. To be changed when moving to other environments.
        ctrl.navigateToLogin = function () {
            
            var link = window.location;
                        
            var url = link.origin + "/account-management-portal/html";

            /*if (link.host.indexOf("insurance.carolinas.aaa.com") >= 0) {
                url = link.origin + "/account";
            }*/
            
            window.open(url, '_blank');

        };

        ctrl._contactNumber = ()=> {
            const acctHolder = $scope.submission.draftData.accountHolder;
            const phoneType = acctHolder.primaryPhoneType;
            if (phoneType === null) {
                return;
            }

            let number;
            if (phoneType === 'work') {
                number = acctHolder.workNumber;
            } else if (phoneType === 'home') {
                number = acctHolder.homeNumber;
            } else if (phoneType === 'mobile') {
                number = acctHolder.cellNumber;
            }
            if (number === null) {
                return;
            }

            return phoneUtils.formatNational(number, LocaleService.getConfiguredPhoneRegion());
        };


        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', '$window', 'LocaleService', '$stateParams', 'StateUtils', 'LoginLinkDev','LoginLinkTest','AAADEV','AAATEST','GWDEV','GWTEST'];
    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/controllers/ConfirmationCtrl.js
 **/